import React from "react";
import { v4 as uuid } from "uuid";

import { useIsInvalid } from "../FormErrorsContext";

export type Props = {
    label: string;
} & Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, `defaultValue`>;

const RadioButton: React.FC<Props> = ({ label, name, value, ...props }) => {
    const isInvalid = useIsInvalid(name);

    const id = `${name}_${value}_${uuid()}`;

    return (
        <div className="mb-5">
            <div className={`form-check form-check-custom form-check-solid ${isInvalid ? `text-danger` : ``}`}>
                <input className="form-check-input" {...props} type="radio" name={name} value={value} id={id} />
                <label className="form-check-label" htmlFor={id}>
                    {label}
                </label>
            </div>
        </div>
    );
};

export default RadioButton;
